module.exports = __webpack_public_path__ + "static/promaid-75cd21a16693efe50a694118d39db243.svg";